<template>
  <div class="px-1">
    <b-row class="my-1" v-if="type === 'modal'">
      <b-col xl="7" lg="7" md="9" sm="9">
        <b-form-group :label="$t('Employee')">
          <b-form-input
            v-model="schedule.full_name"
            disabled
            style="max-width: 350px"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <div class="mt-1">
      <b-table-simple
        ref="schedule"
        class="position-relative font-small-3"
        responsive="sm"
        table-class="text-nowrap"
        small
        show-empty
      >
        <b-thead>
          <b-tr>
            <b-th />
            <b-th class="text-center"> {{ $t("MONDAY") }} </b-th>
            <b-th class="text-center"> {{ $t("TUESDAY") }} </b-th>
            <b-th class="text-center"> {{ $t("WEDNESDAY") }} </b-th>
            <b-th class="text-center"> {{ $t("THURSDAY") }} </b-th>
            <b-th class="text-center"> {{ $t("FRIDAY") }} </b-th>
            <b-th class="text-center"> {{ $t("SATURDAY") }} </b-th>
            <b-th class="text-center"> {{ $t("SUNDAY") }} </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr>
            <b-td>{{ $t("Start") }}</b-td>

            <b-td>
              <component
                :is="onlyView ? 'b-input' : 'v-select'"
                style="min-width: 100px"
                :clearable="false"
                v-model="schedule.start_monday"
                label="hour"
                :reduce="(val) => val.hour"
                :options="quendo"
                :disabled="
                  schedule.work_monday === '1' ? true : false || onlyView
                "
              />
            </b-td>
            <b-td>
              <component
                :is="onlyView ? 'b-input' : 'v-select'"
                style="min-width: 100px"
                :clearable="false"
                v-model="schedule.start_tuesday"
                label="hour"
                :reduce="(val) => val.hour"
                :options="quendo"
                :disabled="
                  schedule.work_tuesday === '1' ? true : false || onlyView
                "
              />
            </b-td>
            <b-td>
              <component
                :is="onlyView ? 'b-input' : 'v-select'"
                style="min-width: 100px"
                :clearable="false"
                v-model="schedule.start_wednesday"
                label="hour"
                :reduce="(val) => val.hour"
                :options="quendo"
                :disabled="
                  schedule.work_wednesday === '1' ? true : false || onlyView
                "
              />
            </b-td>
            <b-td>
              <component
                :is="onlyView ? 'b-input' : 'v-select'"
                style="min-width: 100px"
                :clearable="false"
                v-model="schedule.start_thursday"
                label="hour"
                :reduce="(val) => val.hour"
                :options="quendo"
                :disabled="
                  schedule.work_thursday === '1' ? true : false || onlyView
                "
              />
            </b-td>
            <b-td>
              <component
                :is="onlyView ? 'b-input' : 'v-select'"
                style="min-width: 100px"
                :clearable="false"
                v-model="schedule.start_friday"
                label="hour"
                :reduce="(val) => val.hour"
                :options="quendo"
                :disabled="
                  schedule.work_friday === '1' ? true : false || onlyView
                "
              />
            </b-td>
            <b-td>
              <component
                :is="onlyView ? 'b-input' : 'v-select'"
                style="min-width: 100px"
                :clearable="false"
                v-model="schedule.start_saturday"
                label="hour"
                :reduce="(val) => val.hour"
                :options="quendo"
                :disabled="
                  schedule.work_saturday === '1' ? true : false || onlyView
                "
              />
            </b-td>
            <b-td>
              <component
                :is="onlyView ? 'b-input' : 'v-select'"
                style="min-width: 100px"
                :clearable="false"
                v-model="schedule.start_sunday"
                label="hour"
                :reduce="(val) => val.hour"
                :options="quendo"
                :disabled="
                  schedule.work_sunday === '1' ? true : false || onlyView
                "
              />
            </b-td>
          </b-tr>
          <b-tr>
            <b-td>{{ $t("End") }}</b-td>

            <b-td>
              <component
                :is="onlyView ? 'b-input' : 'v-select'"
                style="min-width: 100px"
                :clearable="false"
                v-model="schedule.end_monday"
                label="hour"
                :reduce="(val) => val.hour"
                :options="quendo"
                :disabled="
                  schedule.work_monday === '1' ? true : false || onlyView
                "
              />
            </b-td>
            <b-td>
              <component
                :is="onlyView ? 'b-input' : 'v-select'"
                style="min-width: 100px"
                :clearable="false"
                v-model="schedule.end_tuesday"
                label="hour"
                :reduce="(val) => val.hour"
                :options="quendo"
                :disabled="
                  schedule.work_tuesday === '1' ? true : false || onlyView
                "
              />
            </b-td>
            <b-td>
              <component
                :is="onlyView ? 'b-input' : 'v-select'"
                style="min-width: 100px"
                :clearable="false"
                v-model="schedule.end_wednesday"
                label="hour"
                :reduce="(val) => val.hour"
                :options="quendo"
                :disabled="
                  schedule.work_wednesday === '1' ? true : false || onlyView
                "
              />
            </b-td>
            <b-td>
              <component
                :is="onlyView ? 'b-input' : 'v-select'"
                style="min-width: 100px"
                :clearable="false"
                v-model="schedule.end_thursday"
                label="hour"
                :reduce="(val) => val.hour"
                :options="quendo"
                :disabled="
                  schedule.work_thursday === '1' ? true : false || onlyView
                "
              />
            </b-td>
            <b-td>
              <component
                :is="onlyView ? 'b-input' : 'v-select'"
                style="min-width: 100px"
                :clearable="false"
                v-model="schedule.end_friday"
                label="hour"
                :reduce="(val) => val.hour"
                :options="quendo"
                :disabled="
                  schedule.work_friday === '1' ? true : false || onlyView
                "
              />
            </b-td>
            <b-td>
              <component
                :is="onlyView ? 'b-input' : 'v-select'"
                style="min-width: 100px"
                :clearable="false"
                v-model="schedule.end_saturday"
                label="hour"
                :reduce="(val) => val.hour"
                :options="quendo"
                :disabled="
                  schedule.work_saturday === '1' ? true : false || onlyView
                "
              />
            </b-td>
            <b-td>
              <component
                :is="onlyView ? 'b-input' : 'v-select'"
                style="min-width: 100px"
                :clearable="false"
                v-model="schedule.end_sunday"
                label="hour"
                :reduce="(val) => val.hour"
                :options="quendo"
                :disabled="
                  schedule.work_sunday === '1' ? true : false || onlyView
                "
              />
            </b-td>
          </b-tr>
          <b-tr>
            <b-td>{{ $t("Remote") }}</b-td>

            <b-td>
              <b-form-checkbox
                v-model="schedule.remote_monday"
                :disabled="
                  schedule.work_monday === '1' ? true : false || onlyView
                "
                value="1"
              />
            </b-td>
            <b-td>
              <b-form-checkbox
                v-model="schedule.remote_tuesday"
                :disabled="
                  schedule.work_tuesday === '1' ? true : false || onlyView
                "
                value="1"
              />
            </b-td>
            <b-td>
              <b-form-checkbox
                v-model="schedule.remote_wednesday"
                :disabled="
                  schedule.work_wednesday === '1' ? true : false || onlyView
                "
                value="1"
              />
            </b-td>
            <b-td>
              <b-form-checkbox
                v-model="schedule.remote_thursday"
                :disabled="
                  schedule.work_thursday === '1' ? true : false || onlyView
                "
                value="1"
              />
            </b-td>
            <b-td>
              <b-form-checkbox
                v-model="schedule.remote_friday"
                :disabled="
                  schedule.work_friday === '1' ? true : false || onlyView
                "
                value="1"
              />
            </b-td>
            <b-td>
              <b-form-checkbox
                v-model="schedule.remote_saturday"
                :disabled="
                  schedule.work_saturday === '1' ? true : false || onlyView
                "
                value="1"
              />
            </b-td>
            <b-td>
              <b-form-checkbox
                v-model="schedule.remote_sunday"
                :disabled="
                  schedule.work_sunday === '1' ? true : false || onlyView
                "
                value="1"
              />
            </b-td>
          </b-tr>
          <b-tr>
            <b-td>{{ $t("Non-working day") }}</b-td>

            <b-td>
              <b-form-checkbox
                v-model="schedule.work_monday"
                value="1"
                :disabled="onlyView"
              />
            </b-td>
            <b-td>
              <b-form-checkbox
                v-model="schedule.work_tuesday"
                value="1"
                :disabled="onlyView"
              />
            </b-td>
            <b-td>
              <b-form-checkbox
                v-model="schedule.work_wednesday"
                value="1"
                :disabled="onlyView"
              />
            </b-td>
            <b-td>
              <b-form-checkbox
                v-model="schedule.work_thursday"
                value="1"
                :disabled="onlyView"
              />
            </b-td>
            <b-td>
              <b-form-checkbox
                v-model="schedule.work_friday"
                value="1"
                :disabled="onlyView"
              />
            </b-td>
            <b-td>
              <b-form-checkbox
                v-model="schedule.work_saturday"
                value="1"
                :disabled="onlyView"
              />
            </b-td>
            <b-td>
              <b-form-checkbox
                v-model="schedule.work_sunday"
                value="1"
                :disabled="onlyView"
              />
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>

    <b-row
      class="my-1 d-flex align-items-center justify-content-between"
      v-if="!onlyView"
    >
      <span class="text-muted fs-note">
        {{
          $t(
            "Note: If you choose the day as a non-working day, the start and end time of that day will be deleted."
          )
        }}
      </span>

      <b-button variant="outline-warning" @click="saveEmployeeSchedule">
        <feather-icon icon="Edit2Icon" class="user-icon" />
        {{ $t("UPDATE") }}
      </b-button>
    </b-row>
  </div>
</template>

<script>
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";
import { mapGetters } from "vuex";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
  },
  props: {
    employeeId: {
      type: Number,
    },
    type: {
      type: String,
      default: "page",
    },
    onlyView: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      schedule: {
        start_sunday: "",
        start_monday: "",
        start_tuesday: "",
        start_wednesday: "",
        start_thursday: "",
        start_friday: "",
        start_saturday: "",
        end_sunday: "",
        end_monday: "",
        end_tuesday: "",
        end_wednesday: "",
        end_thursday: "",
        end_friday: "",
        end_saturday: "",
        remote_sunday: "",
        remote_monday: "",
        remote_tuesday: "",
        remote_wednesday: "",
        remote_thursday: "",
        remote_friday: "",
        remote_saturday: "",
        work_sunday: "",
        work_monday: "",
        work_tuesday: "",
        work_wednesday: "",
        work_thursday: "",
        work_friday: "",
        work_saturday: "",
      },
      ownControl: false,
      quendo: [
        { hour: "06:00" },
        { hour: "06:30" },
        { hour: "07:00" },
        { hour: "07:30" },
        { hour: "08:00" },
        { hour: "08:30" },
        { hour: "09:00" },
        { hour: "09:30" },
        { hour: "10:00" },
        { hour: "10:30" },
        { hour: "11:00" },
        { hour: "11:30" },
        { hour: "12:00" },
        { hour: "12:30" },
        { hour: "13:00" },
        { hour: "13:30" },
        { hour: "14:00" },
        { hour: "14:30" },
        { hour: "15:00" },
        { hour: "15:30" },
        { hour: "16:00" },
        { hour: "16:30" },
        { hour: "17:00" },
        { hour: "17:30" },
        { hour: "18:00" },
        { hour: "18:30" },
        { hour: "19:00" },
        { hour: "19:30" },
        { hour: "20:00" },
        { hour: "20:30" },
        { hour: "21:00" },
        { hour: "21:30" },
        { hour: "22:00" },
        { hour: "22:30" },
        { hour: "23:00" },
        { hour: "23:30" },
      ],
      cont: 1,
    };
  },

  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  async created() {
    await this.getEmployeeSchedule();
  },

  methods: {
    async saveEmployeeSchedule() {
      try {
        const confirm = await this.showConfirmSwal();
        if (confirm.isConfirmed) {
          this.addPreloader();
          let params = {
            schedule: this.schedule,
            employee_id: this.employeeId ?? this.$route.params.id,
          };
          const { data, status } = await EmployeeService.updateEmployeeSchedule(
            params
          );
          if (status === 200) {
            this.getEmployeeSchedule();
            this.showToastSuccess("Schedule updated successfully");
            this.closeModal();
            this.$emit("refreshTable");
          }
        }
      } catch (e) {
        this.showToastError(e);
      } finally {
        this.removePreloader();
      }
    },
    closeModal() {
      this.$emit("close");
    },

    async getEmployeeSchedule() {
      try {
        this.addPreloader();
        const { data, status } = await EmployeeService.getEmployeeSchedule({
          employee_id: this.employeeId ?? this.$route.params.id,
        });
        if (status === 200) {
          this.schedule = data;
        }
      } catch (e) {
        this.showToastError(e);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style scoped>
.fs-note {
  font-size: 0.9rem !important;
  max-width: 50%;
  text-align: justify;
  text-justify: inter-word;
}

@media (max-width: 400px) {
  .fs-note {
    display: none;
    text-align: center;
  }
}
</style>